export default {
  methods: {
    ariaClick(event){
      if(event.key==" " || event.key=="Spacebar" || event.key=="Enter"){
        event.preventDefault();
        event.stopPropagation();
        event.target.click(); 
      }
    },
    ariaSlider(event, callbackLeft, callbackRight){
      if(event.key=="ArrowLeft" || event.key=="Left"){
        event.preventDefault();
        event.stopPropagation();
        callbackLeft(); 
      }
      if(event.key=="ArrowRight" || event.key=="Right"){
        event.preventDefault();
        event.stopPropagation();
        callbackRight(); 
      }
    },
    navigateInModal(list, closeCallback){

      for (const elem of list) {
        const firstFocusableElement = list[0]; 
        const lastFocusableElement = list[list.length - 1]; 
        elem.addEventListener('keydown',(e)=>{
          this.manageNavigationEvent(e, closeCallback, firstFocusableElement, lastFocusableElement);
        })

      }

    },
    manageNavigationEvent(e, closeCallback, firstFocusableElement, lastFocusableElement){
      const isTabPressed = e.key === 'Tab' || e.keyCode === 9;
      if (!isTabPressed) {
        if(e.key === 'Esc' || e.key === 'Escape'){
          e.preventDefault();
          e.stopImmediatePropagation();
          closeCallback();
        }
        return;
      }
      if (e.shiftKey) { // if shift key pressed for shift + tab combination
        if (document.activeElement === firstFocusableElement) {
          lastFocusableElement.focus(); // add focus for the last focusable element
          e.preventDefault();
        }
      } else { // if tab key is pressed
        if (document.activeElement === lastFocusableElement) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
          firstFocusableElement.focus(); // add focus for the first focusable element
          e.preventDefault();
        }
      }
    },
    navigateInMenu(event, menuButtonId, itemsId, clickCallback, closeCallback){
      const activeElementId = document.activeElement.id;
      const currentActiveElementIndex = itemsId.indexOf(
        activeElementId
      );
      let currentActiveElementIsNotFirstItem;
      switch (event.key) {
        case "Spacebar": 
        case " ":
          event.stopImmediatePropagation();
          event.preventDefault();
          if (activeElementId === menuButtonId) {
            clickCallback(event);
          }
          
          break;
        case "Down": // IE/Edge specific value
        case "ArrowDown":
          event.stopImmediatePropagation();
          event.preventDefault();
          if (activeElementId === menuButtonId) {
            document.getElementById(`${itemsId[0]}`).focus();
          }else{
      
            const currentActiveElementIsNotLastItem = currentActiveElementIndex < itemsId.length - 1;
            if (currentActiveElementIsNotLastItem) {
              const nextListItemId = itemsId[currentActiveElementIndex + 1];
              document.getElementById(`${nextListItemId}`).focus();
            }
          }
          break;
        case "Up": // IE/Edge specific value
        case "ArrowUp":
          event.stopImmediatePropagation();
          event.preventDefault();
          currentActiveElementIsNotFirstItem = currentActiveElementIndex > 0;
          if (currentActiveElementIsNotFirstItem) {
            const nextListItemId = itemsId[currentActiveElementIndex - 1];
            document.getElementById(`${nextListItemId}`).focus();
          }
          break;
        case "Enter":
          event.stopImmediatePropagation();
          event.preventDefault();
          event.target.click();
          break;
        case "Esc": // IE/Edge specific value
        case "Escape":
          event.stopImmediatePropagation();
          event.preventDefault();
          closeCallback();
          break;
        
        default:
          return; // Quit when this doesn't handle the key event.
      }
    }
  }
};


